module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid35_920x900.dc98878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid35_920x900.jpg
// module id = 3RqN
// module chunks = 0